import { render } from "./LayoutAuthSidebarContentSubmenu.vue?vue&type=template&id=41611a8f&ts=true"
import script from "./LayoutAuthSidebarContentSubmenu.vue?vue&type=script&lang=ts"
export * from "./LayoutAuthSidebarContentSubmenu.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/eiji/workspace/tradelabo/members.tradelabo.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__